module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/times_on-be3bbfc1fbef42de685ee63565cd1a04.gif";